module.exports = __webpack_public_path__ + "img/user-black.8bfe30e7.svg";